// Keep owner consent out of the dashboard/i18n/analytics dependency graph.
// The HTML prelude already removed the flow fragment before any module loads.
if (window.location.pathname === '/agent-relay/authorize') {
  import('./agentRelay/boot');
} else {
  import('./applicationBoot');
}
